module.exports = __webpack_public_path__ + "static/media/Contact - Map logo.7b79aab3.svg";